<template>
  <div class="q-ml-md">
    <div class="row">
      <div class="row col-12">
        <div>
          <div
            class="row col-12 items-center justify-between text-h6 text-weight-bold text-brand-5 items-center texto-titulo q-pa-md"
          >
            Relatório de Riscos Vinculados
          </div>
        </div>
      </div>
    </div>

    <flexmonster
      :exibir="exibir"
      :link="link"
      :columns="slice"
      :slice="slice"
      :types="types"
      :grid="layout"
      :updateLink="updateLink"
      :showTotals="showTotals"
      :showGrandTotals="showGrandTotals"
      :filtros="filtros"
      :exportName="'Relatorio_Riscos_Vinculados'"
      :gerarCsv="gerarCsv"
      :url="url"
      :urlEp="urlEp"
      :formats="formats"
      :dadosRelatorioSalvo="dados"
      @flexmonsterLoading="loadingStop"
    />
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import Flexmonster from "../../relatorios/components/Flexmonster.vue";

export default {
  components: { Flexmonster },
  setup() {
    const store = useStore();
    const route = useRoute();

    const link = ref("");
    const layout = ref("flat");
    const loadingValue = ref("");
    const types = ref({
      Id_Risco: { type: "string" },
      Matricula_Usuario_Criador_Vinculo: { type: "string" },
    });
    const updateLink = ref(0);
    const exibir = ref(false);
    const filtros = ref("");
    const filtrosObject = ref(null);
    const showTotals = ref("");
    const showGrandTotals = ref("");
    const formats = ref([]);
    const url = ref("");
    const gerarCsv = ref(false);
    const urlEp = ref("");
    const dados = ref({});

    const slice = ref({
      columns: "",
      rows: [{ uniqueName: "ProviderName" }],
      reportFilters: "",
      measures: [
        { uniqueName: "Id_Risco" },
        { uniqueName: "Codigo_Risco" },
        { uniqueName: "Nome_Risco" },
        { uniqueName: "Tipo_Vinculo" },
        { uniqueName: "Codigo_Vinculo" },
        { uniqueName: "Data_Vinculo" },
        { uniqueName: "Nome_Usuario_Criador_Vinculo" },
        { uniqueName: "Matricula_Usuario_Criador_Vinculo" },
        { uniqueName: "Perfil_Usuario_Criador_Vinculo" },
      ],
    });

    const loadingStop = () => {
      loadingValue.value = false;
    };

    const gerarRelatorio = async () => {
      try {
        filtrosObject.value = { controlType: "ca" };
        loadingValue.value = true;

        const response = await store.dispatch(
          "gestaoDeRiscos/relatorioVinculos",
          filtrosObject.value
        );

        link.value = response.data.return?.url || response.data.result?.url;
        updateLink.value++;
        filtros.value = JSON.stringify(filtrosObject);
        url.value = response?.request?.responseURL;
        exibir.value = true;
        loadingValue.value = false;
      } catch {
        loadingValue.value = false;
      }
    };

    const id = route.params.id;
    onMounted(() => {
      gerarRelatorio();
      if (
        id != "carregado" &&
        id != undefined &&
        id != "" &&
        id != "carregadoLink"
      ) {
        store
          .dispatch("rel/listarRelatoriosSalvos", { id })
          .then((response) => {
            let value = response.data.resultado.dados.map((e) => {
              e.template = JSON.parse(e.template);
              return e;
            });
            dados.value = value[0];
            urlEp.value = dados.value.url;
            url.value = dados.value.url;
            gerarCsv.value = true;
          })
          .catch(() => {});
      }
    });

    return {
      link,
      layout,
      loadingValue,
      types,
      updateLink,
      exibir,
      filtros,
      showTotals,
      showGrandTotals,
      formats,
      url,
      gerarCsv,
      urlEp,
      dados,
      slice,
      loadingStop,
      gerarRelatorio,
    };
  },
};
</script>
